import { useEffect } from 'react';
import './styles.scss';

import fotoJersu from '../../../assets/img/grupos/foto 3x4 jersu.jpeg';

import monitoramentoImg from '../../../assets/img/grupos/MONITORAMENTO 24H.png';
import cuponsImg from '../../../assets/img/grupos/CUPONS EXCLUSIVOS.png';
import promoVerdadeImg from '../../../assets/img/grupos/PROMO DE VERDADE.png';
import ofertasRelampagoImg from '../../../assets/img/grupos/OFERTAS RELAMPAGOS.png';
import membrosImg from '../../../assets/img/grupos/+200 MIL MEMBROS ATIVOS.png';
import ofertasDiaImg from '../../../assets/img/grupos/+100 OFERTAS POR DIA_.png';
import estrelasImg from '../../../assets/img/grupos/ESTRELAS_.png';
import compraFinalImg from '../../../assets/img/grupos/SUA PRÓXIMA COMPRA_.png';
import logoJersu from '../../../assets/img/grupos/logo-horizontal.75bc7c31.png';

const redir = 'https://jersu.com.br/redirecionar?tipo=celular';
const pixelId = '1789582035740915';

export default function CelularLanding() {
  useEffect(() => {
    const s = document.getElementById('sticky');
    const h = document.getElementById('ctaHero');
    if (!s || !h) return;
    const io = new IntersectionObserver((es) => {
      es.forEach((e) => {
        if (e.isIntersecting) s.classList.remove('show');
        else s.classList.add('show');
      });
    }, { threshold: 0 });
    io.observe(h);
    return () => io.disconnect();
  }, []);

  useEffect(() => {
    if (!pixelId) return;
    const id = `fb-pixel-${pixelId}`;
    if (document.getElementById(id)) return;

    const script = document.createElement('script');
    script.id = id;
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '${pixelId}');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);

    return () => {
      const el = document.getElementById(id);
      if (el) el.remove();
    };
  }, []);

  return (
    <>
      <noscript>
        <img
          height="1"
          width="1"
          style={{ display: 'none' }}
          src={`https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`}
        />
      </noscript>

      <div id="lp">
        <header className="hero">
          <h1 className="lh2">
            <span className="hl-line">🚨 JERSU INDICA CELULAR</span>
            <span className="hl-line">
              <span className="hl">100% GRATUITO</span> 🚨
            </span>
          </h1>
          <div className="hero-media">
            <div className="ring" />
            <img className="hero-img" src={fotoJersu} alt="CELULAR" />
          </div>
          <p
            className="subhead"
            dangerouslySetInnerHTML={{ __html: 'As melhores promoções de <b>celulares</b> 📱' }}
          />
          <a className="cta" href={redir} id="ctaHero">
            <svg className="ic-wpp" viewBox="0 0 32 32" aria-hidden="true">
              <path d="M16.04 4C9.93 4 4.97 8.96 4.97 15.07c0 2.13.6 4.13 1.64 5.84L4.6 28l7.27-1.9a11 11 0 0 0 4.17.82h.01c6.11 0 11.07-4.96 11.07-11.07C27.12 8.96 22.16 4 16.04 4zm0 20.27h-.01a9.2 9.2 0 0 1-4.69-1.28l-.34-.2-3.48.91.93-3.39-.22-.35a9.18 9.18 0 0 1-1.41-4.9c0-5.08 4.13-9.21 9.22-9.21 2.46 0 4.78.96 6.52 2.7a9.16 9.16 0 0 1 2.7 6.52c0 5.09-4.14 9.21-9.22 9.21zm5.05-6.9c-.28-.14-1.64-.81-1.89-.9-.25-.09-.43-.14-.62.14-.18.28-.71.9-.87 1.08-.16.18-.32.2-.6.07-.28-.14-1.17-.43-2.23-1.38-.82-.74-1.38-1.65-1.54-1.93-.16-.28-.02-.43.12-.57.13-.13.28-.32.42-.49.14-.16.18-.28.28-.46.09-.18.05-.35-.02-.49-.07-.14-.62-1.5-.85-2.05-.22-.54-.45-.47-.62-.48l-.53-.01c-.18 0-.48.07-.73.35-.25.28-.96.94-.96 2.3 0 1.36.99 2.67 1.12 2.85.14.18 1.94 2.96 4.7 4.15.66.28 1.17.45 1.57.58.66.21 1.26.18 1.74.11.53-.08 1.64-.67 1.87-1.32.23-.65.23-1.2.16-1.32-.07-.12-.25-.19-.53-.33z" />
            </svg>
            ENTRAR NO GRUPO
          </a>
          <div className="seals">
            <span>
              <span className="ck">✓</span>
              JÁ SOMOS +200 MIL MEMBROS
            </span>
          </div>
          <div className="scroll-hint">▼ veja o que você recebe</div>
        </header>

        <section className="xiaomi-benefits">
          <div className="xiaomi-benefits-inner">
            <h2 className="xiaomi-benefits-title">
              <strong>Tudo o que precisa para</strong>
              <span>nunca mais pagar caro!</span>
            </h2>

            <div className="xiaomi-benefits-cards">
              <img
                src={monitoramentoImg}
                alt="Monitoramento 24h"
                className="xiaomi-benefit-card"
              />

              <img
                src={cuponsImg}
                alt="Cupons exclusivos"
                className="xiaomi-benefit-card"
              />

              <img
                src={promoVerdadeImg}
                alt="Promoções de verdade"
                className="xiaomi-benefit-card"
              />

              <img
                src={ofertasRelampagoImg}
                alt="Ofertas relâmpago"
                className="xiaomi-benefit-card"
              />
            </div>

            <div className="xiaomi-benefits-stats">
              <img
                src={membrosImg}
                alt="Mais de 200 mil membros ativos"
                className="xiaomi-benefit-stat"
              />

              <img
                src={ofertasDiaImg}
                alt="Mais de 100 ofertas por dia"
                className="xiaomi-benefit-stat"
              />
            </div>

            <div className="xiaomi-benefits-rating">
              <img
                src={estrelasImg}
                alt="Cinco estrelas"
                className="xiaomi-benefits-stars"
              />

              <p>
                MAIS DE 200 MIL PESSOAS JÁ ECONOMIZAM TODO DIA.
              </p>
            </div>
          </div>
        </section>

        <section className="xiaomi-video">
          <div className="xiaomi-video-inner">
            <h2 className="xiaomi-video-title">
              COMO FUNCIONAM<br />
              OS GRUPOS?
            </h2>

            <div className="xiaomi-video-frame">
              <iframe
                src="https://www.youtube.com/embed/90yKNjTXuMI"
                title="Como funcionam os grupos"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              />
            </div>
          </div>
        </section>

        <section className="xiaomi-final">
          <div className="xiaomi-final-inner">
            <div className="xiaomi-final-card">
              <img
                src={compraFinalImg}
                alt="Sua próxima compra pode sair pela metade"
                className="xiaomi-final-bg"
              />

              <div className="xiaomi-final-actions">
                <a
                  href={redir}
                  className="xiaomi-final-cta"
                >
                  <span className="xiaomi-final-cta-label">
                    ENTRAR
                  </span>

                  <span className="xiaomi-final-cta-icon">
                    <svg
                      className="ic-wpp"
                      viewBox="0 0 32 32"
                      aria-hidden="true"
                    >
                      <path d="M16.04 4C9.93 4 4.97 8.96 4.97 15.07c0 2.13.6 4.13 1.64 5.84L4.6 28l7.27-1.9a11 11 0 0 0 4.17.82h.01c6.11 0 11.07-4.96 11.07-11.07C27.12 8.96 22.16 4 16.04 4zm0 20.27h-.01a9.2 9.2 0 0 1-4.69-1.28l-.34-.2-3.48.91.93-3.39-.22-.35a9.18 9.18 0 0 1-1.41-4.9c0-5.08 4.13-9.21 9.22-9.21 2.46 0 4.78.96 6.52 2.7a9.16 9.16 0 0 1 2.7 6.52c0 5.09-4.14 9.21-9.22 9.21zm5.05-6.9c-.28-.14-1.64-.81-1.89-.9-.25-.09-.43-.14-.62.14-.18.28-.71.9-.87 1.08-.16.18-.32.2-.6.07-.28-.14-1.17-.43-2.23-1.38-.82-.74-1.38-1.65-1.54-1.93-.16-.28-.02-.43.12-.57.13-.13.28-.32.42-.49.14-.16.18-.28.28-.46.09-.18.05-.35-.02-.49-.07-.14-.62-1.5-.85-2.05-.22-.54-.45-.47-.62-.48l-.53-.01c-.18 0-.48.07-.73.35-.25.28-.96.94-.96 2.3 0 1.36.99 2.67 1.12 2.85.14.18 1.94 2.96 4.7 4.15.66.28 1.17.45 1.57.58.66.21 1.26.18 1.74.11.53-.08 1.64-.67 1.87-1.32.23-.65.23-1.2.16-1.32-.07-.12-.25-.19-.53-.33z" />
                    </svg>
                  </span>
                </a>

                <p className="xiaomi-final-caption">
                  Entrada gratuita. Vagas limitadas.
                </p>
              </div>
            </div>

            <p className="xiaomi-final-secure">
              🔒 Grupo oficial · Sem custo
            </p>
          </div>
        </section>

        <footer className="xiaomi-footer">
          <div className="xiaomi-footer-inner">
            <img
              src={logoJersu}
              alt="Jersu Indica Ofertas"
              className="xiaomi-footer-logo"
            />

            <div className="xiaomi-footer-copy">
              <p className="xiaomi-footer-line">
                © Jersu |{' '}
                <a href="/politica-privacidade">
                  Políticas de privacidade
                </a>{' '}
                2026
              </p>

              <p className="xiaomi-footer-rights">
                Todos os direitos reservados.
              </p>
            </div>
          </div>
        </footer>

        <div className="sticky" id="sticky">
          <a className="cta" href={redir}>
            <svg className="ic-wpp" viewBox="0 0 32 32" aria-hidden="true">
              <path d="M16.04 4C9.93 4 4.97 8.96 4.97 15.07c0 2.13.6 4.13 1.64 5.84L4.6 28l7.27-1.9a11 11 0 0 0 4.17.82h.01c6.11 0 11.07-4.96 11.07-11.07C27.12 8.96 22.16 4 16.04 4zm0 20.27h-.01a9.2 9.2 0 0 1-4.69-1.28l-.34-.2-3.48.91.93-3.39-.22-.35a9.18 9.18 0 0 1-1.41-4.9c0-5.08 4.13-9.21 9.22-9.21 2.46 0 4.78.96 6.52 2.7a9.16 9.16 0 0 1 2.7 6.52c0 5.09-4.14 9.21-9.22 9.21zm5.05-6.9c-.28-.14-1.64-.81-1.89-.9-.25-.09-.43-.14-.62.14-.18.28-.71.9-.87 1.08-.16.18-.32.2-.6.07-.28-.14-1.17-.43-2.23-1.38-.82-.74-1.38-1.65-1.54-1.93-.16-.28-.02-.43.12-.57.13-.13.28-.32.42-.49.14-.16.18-.28.28-.46.09-.18.05-.35-.02-.49-.07-.14-.62-1.5-.85-2.05-.22-.54-.45-.47-.62-.48l-.53-.01c-.18 0-.48.07-.73.35-.25.28-.96.94-.96 2.3 0 1.36.99 2.67 1.12 2.85.14.18 1.94 2.96 4.7 4.15.66.28 1.17.45 1.57.58.66.21 1.26.18 1.74.11.53-.08 1.64-.67 1.87-1.32.23-.65.23-1.2.16-1.32-.07-.12-.25-.19-.53-.33z" />
            </svg>
            ENTRAR NO GRUPO
          </a>
        </div>
      </div>
    </>
  );
}